import React, { useState } from 'react';
// import logo from './logo.svg';
import './App.css';
import WebSearchbar from './WebSearchbar'
import WebMappage from './WebMapPage'
import MobSrchbar from './MobSearchbar'
import MobMapPage from './MobMapPage'

function App() {

  const [showwebSrch,setWebsrch]=useState(true)
  const [srchfilename,setsrchFilename]=useState('')
  return (<>
    <div className="mainContainer">
        {showwebSrch && <WebSearchbar clickSrch={setWebsrch} setSrchresultname={setsrchFilename} />}
        {!showwebSrch && <WebMappage clickHome={setWebsrch} mapSrcName={srchfilename} />}
    </div>
    <div className='mobmainContainer'>
      {showwebSrch && <MobSrchbar clickSrch={setWebsrch} setSrchresultname={setsrchFilename} />}
      {!showwebSrch && <MobMapPage clickHome={setWebsrch} mapSrcName={srchfilename} />}
    </div>
    </>
  );
}

export default App;
